import "../../../src/App.css";
import PettyCashAccounts from "../../components/PettyCash/PettyCashAccounts";
import PettyCash from "../../components/PettyCash/PettyCash";
import React, { useState } from "react";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import "../../pages/LeadDataReportMaster/LeadDataReportMaster.css";
import { useLocation } from "react-router-dom";


function LeadDataReportMaster() { 
  const location = useLocation();
  const role = location.state?.role;


  return (
    <>
      <div className="d-flex flex-row app">
        <MiniDrawer />

        <div
          className="container-fluid"
          style={{ padding: "4rem 1rem 1rem 1rem", backgroundColor: "#F4F4F4", width: "100%", overflowX: "auto" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "1%",
              }}
            >
              <div>
                <h1 style={{ fontSize: "24px", marginBottom: "2rem" }}>
                  Petty Cash List | <HomeOutlinedIcon />{" "}
                  <span style={{ fontSize: "20px" }}>&gt;&gt;{" "} {role}</span>
                  <span style={{ fontSize: "20px", paddingLeft: "10px" }}>&gt; Petty Cash</span>
                  <span style={{ fontSize: "20px", paddingLeft: "10px" }}>&gt; Petty Cash List</span>
                </h1>
              </div>

            </div>
            <div>
              <Wrapper className="ViewLeadDetails wrapperLeadDataReport" >
              {role === "Accounts" ? <PettyCashAccounts /> : <PettyCash />}
              </Wrapper>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default LeadDataReportMaster;
